const NavbarButton4 = () => {
  return (
    <div className="navbarbutton">
      <a href="./about">About</a>
    </div>
  );
};

export default NavbarButton4;
